import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'

const GET_DISRUPTION_REFERENCE_KEY = 'disruption-reference'

export const useGetDisruptionReference = () =>
    useAppQuery<string>({
        queryKey: [GET_DISRUPTION_REFERENCE_KEY],
        queryFn: () =>
            createInstance({
                url: '/disruptions/reference',
                method: 'GET',
            }),
        staleTime: Infinity,
    })
